import { Box, Button, Rating, Stack, Typography } from "@mui/material";
import { useDarkMode } from "../../../contexts/useDarkModeContext";
import StarIcon from "@mui/icons-material/Star";
import { useState } from "react";
import SectionHeadingButton from "../WeHelpJobSeekers/SectionHeadingButton";
const companiesData = [1, 2, 3, 4, 5, 6, 7, 8];
function TopCompaniesSection() {
  const { darkMode } = useDarkMode();
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <Stack id="top-companies" sx={{ pt: "80px" }}>
      {" "}
      <Typography
        variant="body2"
        sx={{
          fontWeight: "700",
          fontSize: "54px",
          lineHeight: "74px",
          fontFamily: "Inter",
          color: darkMode ? "#ffffff" : "#0E0B33",
          textAlign: "center",
          mb: "4px",
        }}
      >
        Top Companies
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: "400",
          fontSize: "18px",
          lineHeight: "30px",
          fontFamily: "Inter",
          color: darkMode ? "#8d8d8d" : "#878599",
          pt: "4px",
          textAlign: "center",
        }}
      >
        Explore and find the dream job opportunities with our best companies and
        employers.
      </Typography>
      <Stack
        direction="row"
        id="top-companies-cards"
        sx={{
          px: "98px",
          py: "60px",
          flexWrap: "wrap",
          gap: "20px",
          rowGap: "22px",
          justifyContent: "center",
        }}
      >
        {companiesData.map((company, i) => {
          const activeCompnay = i === activeIndex;
          return (
            <Stack
              component="button"
              id="card"
              sx={{
                border: darkMode
                  ? activeCompnay
                    ? "none"
                    : "1px solid #464646"
                  : "1px solid #E4E4E4",
                p: "19.5px",
                px: "19px",
                borderRadius: "20px",
                minWidth: "323.5px",
                bgcolor: darkMode
                  ? activeCompnay
                    ? "#000000"
                    : "transparent"
                  : activeCompnay
                  ? "#000000"
                  : "#ffffff",
                cursor: "pointer",
              }}
              onClick={() => setActiveIndex(i)}
            >
              <Stack direction="row" sx={{ alignItems: "center", gap: "12px" }}>
                {" "}
                <Box
                  component="img"
                  src="/images/marketingGenius.jpg"
                  sx={{
                    width: "70px",
                    height: "70px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    display: "block",
                  }}
                ></Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  {" "}
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "700",
                      fontSize: "18px",
                      lineHeight: "23px",
                      fontFamily: "Inter",
                      color: darkMode
                        ? "#ffffff"
                        : activeCompnay
                        ? "#ffffff"
                        : "#0E0B33",
                      width: "110px",
                      pb: "2px",
                      textAlign: "start",
                    }}
                  >
                    TechWorks Incorporation
                  </Typography>
                  <Rating
                    sx={{
                      alignSelf: "start",
                      color: "#FBCF5E", // Change the color of filled stars
                      "& .MuiRating-iconEmpty": {
                        color: "#c3c2cc", // Fully fill empty stars
                      },
                    }}
                    emptyIcon={
                      <StarIcon
                        style={{
                          color: darkMode
                            ? activeCompnay
                              ? "#ffffff"
                              : "#d3d3d3"
                            : activeCompnay
                            ? "#ffffff"
                            : "#c3c2cc",
                        }}
                        fontSize="inherit"
                      />
                    }
                    name="size-small"
                    defaultValue={2}
                    size="small"
                  />
                </Box>
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ pt: "18px" }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <Box
                    component="img"
                    sx={{ width: "18px", height: "18px" }}
                    src={`./icons/employeeIcon${
                      darkMode
                        ? activeCompnay
                          ? "White"
                          : "DarkModeUnActive"
                        : activeCompnay
                        ? "White"
                        : ""
                    }.svg`}
                  ></Box>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: "400",
                      fontSize: "14px",
                      lineHeight: "20px",
                      fontFamily: "Inter",
                      color: darkMode
                        ? activeCompnay
                          ? "#ffffff"
                          : "#c6c6c6"
                        : activeCompnay
                        ? "#ffffff"
                        : "#4a4866",
                    }}
                  >
                    3,567 employees
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontFamily: "Inter",
                    color: darkMode
                      ? activeCompnay
                        ? "#ffffff"
                        : "#c6c6c6"
                      : activeCompnay
                      ? "#ffffff"
                      : "#4a4866",
                  }}
                >
                  20 jobs open
                </Typography>
              </Stack>
            </Stack>
          );
        })}
      </Stack>
      {/* <Button
        variant="text"
        sx={{
          textTransform: "none",
          alignSelf: "center",
          color: darkMode ? "#FFFFFF" : "#0E0B33",
          bgcolor: "transparent",
          textDecoration: "underline",
          p: "0px",
          // pb: "20px",
          fontSize: "20px",
          lineHeight: "30px",
          fontWeight: "700",
          textDecorationThickness: "2px", // Controls thickness
          textUnderlineOffset: "8px", // Adjusts space between text and underline
          "&:hover": {
            backgroundColor: "transparent", // Removes hover background
            textDecoration: "underline", // Ensures underline stays
          },
        }}
      >
        View All Top Companies
      </Button> */}
      <SectionHeadingButton>View All Top Companies</SectionHeadingButton>
    </Stack>
  );
}

export default TopCompaniesSection;
